/* eslint-disable */
/*

usage:

p = new Render({
  render: true | false,                // defaults to "true"
  webgl: true | false | "auto",        // defaults to "auto"
  preserveDrawingBuffer: true | false, // defaults to "false"
  contextOptions: {},                  // defaults to empty
  size: {
    width: <Numeric>,                  // defaults to "200"
    height: <Numeric>                  // defaults to "200"
  }
});

// canvas property represents the canvas node
// put it somewhere in the dom
p.canvas;

p.webgl; // contains the used rendering mode. if you pass auto to webgl you can see what auto detection resulted in

p.renderType; // 支持的数据类型： yuv | rgb

*/

import YUVCanvas from './YUVCanvas';
import utils from '../../utils';

const Render = function(parOptions) {
  this._config = parOptions || {};
  
  this.render = true;
  if (this._config.render === false){
    this.render = false;
  };
  
  if (this._config.preserveDrawingBuffer){
    this._config.contextOptions = this._config.contextOptions || {};
    this._config.contextOptions.preserveDrawingBuffer = true;
  };
  
  var webgl = "auto";
  if (this._config.webgl === true){
    webgl = true;
  }else if (this._config.webgl === false){
    webgl = false;
  };
  
  if (webgl == "auto"){
    webgl = true;
    try{
      if (!window.WebGLRenderingContext) {
        // the browser doesn't even know what WebGL is
        webgl = false;
      } else {
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext("webgl");
        if (!ctx) {
          // browser supports WebGL but initialization failed.
          webgl = false;
        };
      };
    }catch(e){
      webgl = false;
    };
  };
  
  this.webgl = webgl;
  
  // choose functions
  if (this.webgl){
    this.createCanvasObj = this._createCanvasWebGL;
    this.renderFrame = this._renderFrameWebGL;
    this.renderType = 'yuv';
  }else{
    this.createCanvasObj = this._createCanvasRGB;
    this.renderFrame = this._renderFrameRGB;
    this.renderType = 'rgb';
  };
  
  // provide size
  
  if (!this._config.size){
    this._config.size = {};
  };
  this._config.size.width = this._config.size.width || 200;
  this._config.size.height = this._config.size.height || 200;
  
  if (this.render){
    this.canvasObj = this.createCanvasObj({
      contextOptions: this._config.contextOptions
    });
    this.canvas = this.canvasObj.canvas;
  };
  this.domNode = this.canvas;
};

function RNDTO32(v) {
  return (v % 32) ? ((v + 32) & 0xFFFFFFE0) : v;
}

Render.prototype = {

  draw: function(buffer, width, height, infos) {
    
    if (!buffer || !this.render) {
      return;
    };
    
    this.renderFrame({
      canvasObj: this.canvasObj,
      data: buffer,
      width: width,
      height: height,
      infos: infos
    });
  },

  
  destroy: function() {
      
  },

  // for both functions options is:
  //
  //  width
  //  height
  //  enableScreenshot
  //
  // returns a object that has a property canvas which is a html5 canvas
  _createCanvasWebGL: function(options){
    var canvasObj = this._createBasicCanvasObj(options);
    canvasObj.contextOptions = options.contextOptions;
    return canvasObj;
  },
  
  _createCanvasRGB: function(options){
    var canvasObj = this._createBasicCanvasObj(options);
    return canvasObj;
  },
  
  // part that is the same for webGL and RGB
  _createBasicCanvasObj: function(options){
    options = options || {};
    
    var obj = {};
    var width = options.width;
    if (!width){
      width = this._config.size.width;
    };
    var height = options.height;
    if (!height){
      height = this._config.size.height;
    };
    obj.canvas = document.createElement('canvas');
    obj.canvas.width = width;
    obj.canvas.height = height;
    //obj.canvas.style.backgroundColor = "#0D0E1B";
    
    return obj;
  },
  
  // options:
  //
  // canvas
  // data
  _renderFrameWebGL: function(options){
    
    var canvasObj = options.canvasObj;
    
    var width = options.width || canvasObj.canvas.width;
    var height = options.height || canvasObj.canvas.height;
    var infos = options.infos || {};

    if (canvasObj.canvas.width !== width ||
        canvasObj.canvas.height !== height ||
        !canvasObj.webGLCanvas){
      canvasObj.canvas.width = width;
      canvasObj.canvas.height = height;
      canvasObj.webGLCanvas = new YUVCanvas({
        canvas: canvasObj.canvas,
        contextOptions: canvasObj.contextOptions,
        width: width,
        height: height
      });
    };

    const ystride  = infos.yStride;
    const uvstride = infos.uvStride;
    const ysize    = ystride * infos.height;
    const vusize   = uvstride * ( infos.height / 2 );
    const size     = ysize + ( 2 * vusize )

    //console.log(infos, ysize, vusize);

    if (options.data.length < size) {
        throw new Error('Invalid "YUV" data');
        //return;
    }

    canvasObj.webGLCanvas.drawNextOutputPicture({
      yData: options.data.subarray(0, ysize),
      uData: options.data.subarray(ysize, ysize + vusize),
      vData: options.data.subarray(ysize + vusize,  ysize + vusize + vusize),
      yDataPerRow: ystride,
      uDataPerRow: uvstride
    });
    
  },

  _renderFrameRGB: function(options){
    var canvasObj = options.canvasObj;
    var width = options.width || canvasObj.canvas.width;
    var height = options.height || canvasObj.canvas.height;
    
    if (canvasObj.canvas.width !== width || canvasObj.canvas.height !== height){
      canvasObj.canvas.width = width;
      canvasObj.canvas.height = height;
    };
    
    var ctx = canvasObj.ctx;
    var imgData = canvasObj.imgData;
    if (!ctx){
      canvasObj.ctx = canvasObj.canvas.getContext('2d');
      ctx = canvasObj.ctx;
      canvasObj.imgData = ctx.createImageData(width, height);
      imgData = canvasObj.imgData;
    };
    imgData.data.set(options.data);
    console.log("imgData")
    console.log(imgData)
    ctx.putImageData(imgData, 0, 0);
    
  }
  
};
  
export default Render;
